"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["LenderRecommendation"] = 1] = "LenderRecommendation";
    DocumentType[DocumentType["RecentCreditReport"] = 2] = "RecentCreditReport";
    DocumentType[DocumentType["ConfirmationOfIncome"] = 3] = "ConfirmationOfIncome";
    DocumentType[DocumentType["BuildingInspectionReport"] = 4] = "BuildingInspectionReport";
    DocumentType[DocumentType["AppraisalReport"] = 5] = "AppraisalReport";
    DocumentType[DocumentType["TaxStatement"] = 6] = "TaxStatement";
    DocumentType[DocumentType["LocalContractorQuotes"] = 7] = "LocalContractorQuotes";
    DocumentType[DocumentType["Other"] = 8] = "Other";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
